import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useUserStore } from 'stores';


const RequireAuth = ({ children  }) => {
  const { isLogged } = useUserStore();
  const location = useLocation();

  if (isLogged) {
    return children;
  } else {
    return <Navigate to={`/intranet/login`} state={{ from: location }} />;
  }
};

export default RequireAuth;
